import gql from 'graphql-tag';

export const ALL_VENUES_QUERY = gql`
  query getVenues {
    user {
      id
      company {
        id
      }
      venues {
        id
        active
        name
        company {
          id
          name
        }
        location {
          id
          name
          street
        }
        nameLang {
          id
          en
          se
          no
          es
        }
      }
    }
  }
`;
